

class insulinResistanceQuiz extends HTMLElement {
    constructor() {
        super();

        //Selectors
        this.topHeader='[data-quiz-topbar]';

        // Init Slider (Do not remove)
        this._initSlider()

        // Init Variables
        this.scoresData=[];
        this.numberWords = ["zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine","ten"];
        this.allResultsItems=[];
        
        // Init Actions
        this.scoreEle=this.querySelectorAll('[data-scoreJson]');
        this.scoreEle.forEach((ele)=>{
            this.scoresData.push(JSON.parse(ele.textContent));
        })
        
        //Bind Events
        this.backButton=this.querySelector('[data-back-button]')
        this.backButton?.addEventListener('click', this._previousSlide.bind(this));

        this.btnEles = this.querySelectorAll('[data-button-action]');
        this.btnEles.forEach(btnEle => btnEle.addEventListener('click', this._stepActions.bind(this)));

        this.addButtons = this.querySelectorAll('[data-add_items]');
        this.addButtons.forEach(addBtn => addBtn.addEventListener('click', this._addBundleProducts.bind(this)));

        this.inputEvents=this.querySelectorAll('[data-BMI-inputs] input');
        this.inputEvents.forEach(ele => ele.addEventListener('input', this._manageShowResultBtn.bind(this)));
    }

    /**
     * Hiding element 
     * @param {*} ele 
     */
    _hidElement=(ele)=>{
        this.querySelectorAll(ele).forEach(ele=>{
            ele.classList.add('hide');
        })
    }

    /**
     * Remove hide class from element 
     * @param {*} ele 
     */
    _showElement=(ele)=>{
        this.querySelectorAll(ele).forEach(ele=>{
            ele.classList.remove('hide');
        })
    }

    /**
     * Add Selected class for highlighting 
     * @param {*} event 
     */
    _addSelectedClass=(event)=>{
        event.target.closest('[data-single-quiz]')?.querySelector('[data-button-action].selected')?.classList.remove('selected');
        event.target.closest('[data-button-action]')?.classList.add('selected');
    }

    _stepActions=(event)=>{
        event.preventDefault();
        this._navigateToNextSlide();
        let currenIndex=this._activeIndex();
        if (currenIndex == 0) {
            this._hidElement(this.topHeader);
        }else if(event.target.closest('[data-button-action]').getAttribute('data-button-action') == 'show-results'){
            this._hidElement(this.topHeader);
            this._displayResult();
        }else{
            this._showElement(this.topHeader);
            this._addSelectedClass(event);
        }

    }
    
    /**
     * Hide Show result button based on input event
     * @param {*} event 
     */
    _manageShowResultBtn=(event)=>{
        this.querySelector('[data-button-action="show-results"]').classList.remove('hidden');
        let inputEles=this.querySelectorAll('[data-BMI-inputs] input');
        inputEles.forEach(ele=>{
            if (ele.value == '') {
                this.querySelector('[data-button-action="show-results"]').classList.add('hidden');    
            }
        });
    }

    _displayResult=()=>{
        let totalScore=this._totalScore()+this._calculateBMIscore();
        this.querySelector('[data-total-score]').innerHTML=totalScore;
        
        let result=this._fetchResultText(totalScore);

        this.querySelector('[data-result-text]').innerHTML=result.result;

        this._fetchResultProducts(result);
    }

    _calculateBMIscore=()=>{
        let weight=this.querySelector('[name="weight"]').value;
        let height=this.querySelector('[name="height"]').value;

        // Square the height
        const squaredHeight = height * height;

        // Calculate BMI
        const BMIscore = ((weight / squaredHeight) * 703).toFixed(1); // Round the BMI to 1 decimal place
        return BMIscore > 25 ? 1 : 0;
        
    }
    _totalScore=()=>{
        return this.querySelectorAll('[data-button-action="true"].selected').length;
    }

    _fetchResultText=(totalScore)=>{
        let result=this.scoresData.find((tempResult)=> {return totalScore <= tempResult.score} );
        return result;
    }

    _fetchResultProducts=(result)=>{
        const discountPercentage = 10;
        this.allResultsItems=result.products;
        let totalAmount=0;
        let totalItemCount=0;
        this.querySelectorAll('[data-product-id]').forEach((ele)=>{
            let eleId=ele.getAttribute('data-product-id')
            let item=this.allResultsItems.find(pro => {return pro.id == eleId});
            if(item){
                totalAmount+=item.variants[0].price;
                totalItemCount++;
                ele.classList.remove('d-none');
            }else{
                ele.classList.add('d-none');
            }
            if (ele.querySelector('[data-required-qty]')) {
                ele.querySelector('[data-required-qty]').innerHTML = result.quantity;
                if (result.quantity == 1) {
                    ele.querySelector('[data-required-qty]').closest('p')?.classList.add('d-none');
                }else{
                    ele.querySelector('[data-required-qty]').closest('p')?.classList.remove('d-none');
                }
            }
            ele.querySelector('[name="quantity"]').value=(result.quantity || 1)
        })
        
        const discountedTotal = totalAmount - (totalAmount * discountPercentage) / 100;
        this.querySelectorAll('[data-add_items]').forEach((ele)=>{
            if (ele.querySelector('[data-total_items]')) {
                ele.querySelector('[data-total_items]').innerHTML=this.numberWords[totalItemCount]||totalItemCount;
            }
            if (ele.querySelector('[data-original-total]')) {
                ele.querySelector('[data-original-total]').innerHTML=Shopify.formatMoney(discountedTotal, window.globalVariables.money_format);
            }
            if (ele.querySelector('[data-discounted-total]')) {
                ele.querySelector('[data-discounted-total]').innerHTML=Shopify.formatMoney(totalAmount, window.globalVariables.money_format);
            }
        })
    }

    _addBundleProducts=async (event)=>{
        event.preventDefault();
        let itemArray=[];
        this.allResultsItems.forEach((item)=>{
            itemArray.push({
                id: item.variants[0].id,
                quantity: 1,
                properties:{
                    _bundle: `true`
                }
            })
        })
        event.target.closest('a')?.classList.add('loading');
        let response=await fetch('/cart/add.js',{
            ...fetchConfig(),
            body: JSON.stringify({items:itemArray})
        });
        if (response.ok) {
            let data=await response.json();
            document.querySelector('ajax-cart').getCartData('open_drawer')
        }else{
            Utility.notification('Something went wrong','Error in adding bundle','error')
        }
        event.target.closest('a')?.classList.remove('loading');
    }
    /**
     * Slider actions
     */
    _initSlider=()=>{

        let sliderElement = this.querySelector('.swiper-slider');
        if(!sliderElement) return;
        
        let sliderOptions = sliderElement.getAttribute('data-slider');
        sliderOptions = JSON.parse(sliderOptions);

        // Set up nav slider 
        if(sliderElement.hasAttribute('data-nav')){
        let thumbSlider = document.querySelector('.'+sliderElement.getAttribute('data-nav'));
        if(!thumbSlider){
            return;
        }
        let thumbSliderOptions = thumbSlider.getAttribute('data-slider');
        thumbSliderOptions = JSON.parse(thumbSliderOptions);
        thumbSlider = new Swiper(thumbSlider, thumbSliderOptions);

        sliderOptions.thumbs = {
                swiper: thumbSlider
            }
        }
        
        this.slider = new Swiper(sliderElement, sliderOptions);
    }
    _activeIndex=()=>{
        if (this.querySelector('[data-current-index]')) {
            this.querySelector('[data-current-index]').innerHTML=this.slider.activeIndex;
        }
        return this.slider.activeIndex;
    }

    _navigateSlide=(index)=>{
        this.slider.slideTo(index)
    }

    _navigateToNextSlide=()=>{
        this.slider.slideNext();
    }

    _previousSlide=()=>{
        this.slider.slidePrev();
        let currenIndex=this._activeIndex();
        if (currenIndex == 0) {
            this._hidElement(this.topHeader);
        }
    }
}
customElements.define('insulin-resistance-quiz', insulinResistanceQuiz);